//messages.js
export default {
    sensor_type: "Tipo de sensor",
    sensor_description: "Descripción del sensor",
    measurement_symbol: "Símbolo de medición",
    imperial_symbol: "Símbolo imperial",
    metric_symbol: "Símbolo métrico",
    round_precision: "Precisión de redondeo",
};
